import React, { useState } from "react";
import { Modal, Button, Form, FloatingLabel } from "react-bootstrap";
import { RiUpload2Fill } from "react-icons/ri";

const CreateClubModal = ({ show, onHide }) => {
  const [clubName, setClubName] = useState("");
  const [clubDescription, setClubDescription] = useState("");
  const [clubGenre, setClubGenre] = useState("");
  const [clubType, setClubType] = useState("Private");
  const [clubImage, setClubImage] = useState(null);
  const [errors, setErrors] = useState({});

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setClubImage(URL.createObjectURL(file));
    }
  };

  const removeImage = () => {
    setClubImage(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!clubName) newErrors.clubName = "Club name is required.";
    if (!clubDescription) newErrors.clubDescription = "Club description is required.";
    if (!clubGenre) newErrors.clubGenre = "Select a genre.";

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      onHide(); // Close modal after submission
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="md" centered className="auth-modal">
      <Modal.Header closeButton>
        <Modal.Title>Create a Club</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="create-club-container">
          <Form onSubmit={handleSubmit}>
            {/* Image Upload Section */}
            <div className="upload-section mb-3 text-center">
              <label className="upload-box">
                {clubImage ? (
                  <div className="image-preview">
                    <img src={clubImage} alt="Club" className="preview-image" />
                    <span className="remove-btn" onClick={removeImage}>×</span>
                  </div>
                ) : (
                  <>
                    <RiUpload2Fill className="upload-icon" />
                    <p>Upload image</p>
                    <span>Size 512 x 512px</span>
                  </>
                )}
                <input type="file" accept="image/*" hidden onChange={handleImageChange} />
              </label>
            </div>

            {/* Club Name */}
            <FloatingLabel controlId="floatingClubName" label="Club Name" className="mb-3">
              <Form.Control
                type="text"
                placeholder="Club Name"
                value={clubName}
                onChange={(e) => setClubName(e.target.value)}
                className={errors.clubName ? "is-invalid" : ""}
              />
              {errors.clubName && <div className="text-danger mt-1">{errors.clubName}</div>}
            </FloatingLabel>

            {/* Club Description */}
            <FloatingLabel controlId="floatingClubDescription" label="Enter Club Description" className="mb-3">
              <Form.Control
                as="textarea"
                placeholder="Enter Club Description"
                style={{ height: "100px" }}
                value={clubDescription}
                onChange={(e) => setClubDescription(e.target.value)}
                className={errors.clubDescription ? "is-invalid" : ""}
              />
              {errors.clubDescription && <div className="text-danger mt-1">{errors.clubDescription}</div>}
            </FloatingLabel>

            {/* Genre Selection */}
            <FloatingLabel controlId="floatingGenre" label="Select Genre" className="mb-3">
              <Form.Select
                value={clubGenre}
                onChange={(e) => setClubGenre(e.target.value)}
                className={errors.clubGenre ? "is-invalid" : ""}
              >
                <option value="">Select Genre</option>
                <option value="Music">Music</option>
                <option value="Sports">Sports</option>
                <option value="Gaming">Gaming</option>
                <option value="Technology">Technology</option>
              </Form.Select>
              {errors.clubGenre && <div className="text-danger mt-1">{errors.clubGenre}</div>}
            </FloatingLabel>

            {/* Club Type Selection */}
            <FloatingLabel controlId="floatingClubType" label="Select Type" className="mb-3">
              <Form.Select value={clubType} onChange={(e) => setClubType(e.target.value)}>
                <option value="Private">Private</option>
                <option value="Public">Public</option>
              </Form.Select>
            </FloatingLabel>

            {/* Create Club Button */}
            <div className="text-center">
              <Button type="submit" className="btn btn-primary w-100 create-club-btn">Create Club</Button>
            </div>
          </Form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CreateClubModal;
